var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedureManagementActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 3.00012H13.4999C13.8977 3.00012 14.2792 3.15817 14.5605 3.43949C14.8418 3.72082 14.9998 4.10238 14.9998 4.50024V15.0011C14.9998 15.3989 14.8418 15.7805 14.5605 16.0618C14.2792 16.3432 13.8977 16.5012 13.4999 16.5012H4.50083C4.10304 16.5012 3.72155 16.3432 3.44027 16.0618C3.159 15.7805 3.00098 15.3989 3.00098 15.0011V4.50024C3.00098 4.10238 3.159 3.72082 3.44027 3.43949C3.72155 3.15817 4.10304 3.00012 4.50083 3.00012H6.00068M6.7506 1.5H11.2502C11.6643 1.5 12.0001 1.83581 12.0001 2.25006V3.75018C12.0001 4.16443 11.6643 4.50024 11.2502 4.50024H6.7506C6.33643 4.50024 6.00068 4.16443 6.00068 3.75018V2.25006C6.00068 1.83581 6.33643 1.5 6.7506 1.5Z",
    stroke: "#5921F2",
    strokeWidth: 1.13,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedureManagementActive);
export default __webpack_public_path__ + "static/media/ProcedureManagementActive.621334edba58c195720babe027e0111e.svg";
export { ForwardRef as ReactComponent };